/* tslint:disable:no-string-literal */

import * as Preact from 'preact'
import { FifaDivider } from '../FifaDivider'
import { FifaLogo } from '../Logos/FifaLogo'
import { NrkSportLogo } from '../Logos/NrkSportLogo'
import { Byline } from './Byline'
import { Copyright } from './Copyright'
const { h } = Preact
const styles = require('./index.css')

const Footer = () => {
  return (
    <footer class={styles['footer']}>
      <div class={styles['footer__logos']}>
        <FifaLogo class={styles['footer__fifa-logo']} />
        <FifaDivider class={styles['footer__fifa-divider']} />
        <a class={styles['footer__nrk-logo']} href="https://www.nrk.no/sport/">
          <NrkSportLogo rounded={true} />
        </a>
      </div>
      <div class={styles['footer__disclaimer']}>Official Broadcaster</div>
      <div class={styles['footer__contact-info']}>
        <div>
          Telefon: <strong>23 04 70 00</strong>
        </div>
        <div>
          E-post: <a href="mailto:sporten@nrk.no">sporten@nrk.no</a>
        </div>
        <div>
          <a href="https://www.nrk.no/etikk/redaktoransvar-pa-nrk.no-1.2843526">
            Sportsredaktør: Egil Sundvor
          </a>
        </div>
        <div>
          <a href="https://www.nrk.no/etikk/redaktoransvar-pa-nrk.no-1.2843526">
            Ansvarlig redaktør: Thor Gjermund Eriksen
          </a>
        </div>
        <div>
          <a href="https://www.nrk.no/etikk/redaktoransvar-pa-nrk.no-1.2843526">
            Nettsjef: Hildegunn Soldal
          </a>
        </div>
      </div>
      <div class={styles['footer__copyright']}>Opphavsrett NRK &copy; 2018</div>
    </footer>
  )
}

export { Footer }
